import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback } from 'react';
import { addSpanToAll } from '@atlaskit/react-ufo/interaction-metrics';
import { HttpResponseError } from '@atlassian/commerce-service-hook';
import { useSentryExceptionDispatch } from '@atlassian/commerce-telemetry/dispatch-hooks';
import { sanitizeUrlString } from '../../common/utils/sanitize-url';
import { useCommerceOverride } from '../use-commerce-override';
import { getRequestUrl } from './utils';
export var useCommerceFetch = function useCommerceFetch() {
  var commerceContextFetch = useCommerceOverride(fetch);
  var dispatchSentryException = useSentryExceptionDispatch();
  return useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var startTime,
      _len,
      args,
      _key,
      fetchInput,
      sanitizedUrl,
      response,
      oldErrorMessage,
      newErrorMessage,
      wrappedError,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          startTime = performance.now();
          for (_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = _args[_key];
          }
          fetchInput = args[0];
          sanitizedUrl = sanitizeUrlString(getRequestUrl(fetchInput));
          _context.prev = 4;
          _context.next = 7;
          return commerceContextFetch.apply(void 0, args);
        case 7:
          response = _context.sent;
          if (response.status >= 400) {
            dispatchSentryException({
              exception: new Error("Status: ".concat(response.status, "\nURL: ").concat(sanitizedUrl))
            });
          }
          addSpanToAll('fetch', sanitizedUrl, [{
            name: 'network'
          }], startTime, performance.now(), JSON.stringify(response).length);
          return _context.abrupt("return", response);
        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](4);
          // eslint-disable-next-line no-console
          console.warn(_context.t0);
          oldErrorMessage = function () {
            if (_context.t0 instanceof Error) {
              var _error$stack;
              return (_error$stack = _context.t0.stack) !== null && _error$stack !== void 0 ? _error$stack : _context.t0.toString();
            } else {
              return JSON.stringify(_context.t0);
            }
          }();
          newErrorMessage = "An error occurred when fetching from ".concat(sanitizedUrl, "\n\n ").concat(oldErrorMessage);
          wrappedError = new Error(newErrorMessage);
          dispatchSentryException({
            exception: wrappedError
          });
          throw _context.t0;
        case 21:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[4, 13]]);
  })), [commerceContextFetch, dispatchSentryException]);
};
export var reportHttpError = function reportHttpError(request, dispatchSentryException) {
  return request.catch(function (error) {
    // reportHttpError doesn't dispatch url as HttpResponseError has a resource name in the message
    if (error instanceof HttpResponseError) {
      dispatchSentryException({
        exception: error
      });
    }
    var oldErrorMessage = function () {
      if (error instanceof Error) {
        var _error$stack2;
        return (_error$stack2 = error.stack) !== null && _error$stack2 !== void 0 ? _error$stack2 : error.toString();
      } else {
        return JSON.stringify(error);
      }
    }();
    var newErrorMessage = "An error occurred when fetching data\n\n ".concat(oldErrorMessage);
    dispatchSentryException({
      exception: new Error(newErrorMessage)
    });
    return error;
  });
};